import React from "react";
import { ArrowRight, Check } from "react-feather";
import TopNavBar from "./TopNavBar";
import CustomLink from "../CustomLink";
import { useTranslation } from "react-i18next";

function QuizComparisonMessage() {
  const { t } = useTranslation();

  return (
        <main className="t-min-h-[65vh]">
          <section className="t-pt-6">
            <div className="container">
              <TopNavBar title={t('QuizComparison_NavTitle')} />
            </div>
          </section>
          <section className="t-py-12 md:t-py-16">
            <div className="container">
              <div className="t-flex t-flex-col t-items-center t-text-center">
                <div className="t-mb-6 t-flex t-h-16 t-w-16 t-items-center t-justify-center t-rounded-full t-bg-teal-bg t-text-quiz-teal">
                  <Check size={30} strokeWidth={2} aria-hidden="true" />
                </div>
                <h1 className="t-m-0 t-font-serif t-text-3xl t-leading-tight t-text-navy md:t-text-4xl">
                  {t("QuizComparisonMessage_Title")}
                </h1>
                <p className="t-m-0 t-mt-4 t-max-w-md t-text-base t-leading-relaxed t-text-teal-muted">
                  {t("QuizComparisonMessage_Body")}
                </p>
                <CustomLink
                  to="/dashboard"
                  className="t-mt-8 t-inline-flex t-min-h-[48px] t-max-w-full t-items-center t-justify-center t-gap-3 t-rounded-lg t-bg-quiz-teal t-px-6 t-py-3 t-text-sm t-font-semibold !t-text-white t-transition hover:t-opacity-90 focus-visible:t-outline focus-visible:t-outline-2 focus-visible:t-outline-offset-4 focus-visible:t-outline-quiz-teal"
                >
                  <span>{t("QuizComparisonMessage_CustomerArea")}</span>
                  <ArrowRight size={18} className="t-shrink-0" aria-hidden="true" />
                </CustomLink>
              </div>
            </div>
          </section>
        </main>
  );
}

export default QuizComparisonMessage;
